import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { EmojiDizzy, PlusCircle, Stack, Tag } from 'react-bootstrap-icons';

const MarkerThumb = ({
	className,
	groups,
	icon,
	markers,
	product_type,
	size = 'sm',
}) => {
	const group_id = groups && groups.length == 1 ? groups[0] : null;
	const marker_id = markers && markers.length == 1 ? markers[0] : null;
	const result = useStaticQuery(graphql`
		query MarkersThumb {
			allMarker {
				nodes {
					marker_id
					symbol
				}
			}
		}
	`);

	let symbol = '';
	const marker = result.allMarker.nodes.find(
		(value) => value.marker_id == marker_id,
	);
	if (marker && marker.symbol) symbol = marker.symbol;

	const bgColors = [
		'lavendel',
		'dustypink',
		'military',
		'atlas',
		'mustard',
		'florens',
		'plotum',
		'beige',
		'imagine',
	];
	const backgroundColor = bgColors[group_id % bgColors.length];

	return (
		<div
			className={`bg-${backgroundColor} thumb-${size} thumb-marker fw-500 d-flex align-items-center justify-content-center ${className}`}
		>
			<span className={`text-dark o-60 thumb-text `}>
				{icon == 'extra' && <Tag />}
				{!icon && product_type && (!markers || !markers.length) && (
					<PlusCircle />
				)}
				{!icon && !product_type && (!markers || !markers.length) && (
					<EmojiDizzy />
				)}
				{markers && markers.length === 1 && <>{symbol}</>}
				{markers && markers.length > 1 && <Stack />}
			</span>
		</div>
	);
};

MarkerThumb.propTypes = {
	className: PropTypes.string,
	groups: PropTypes.array,
	icon: PropTypes.string,
	markers: PropTypes.array,
	product_type: PropTypes.string,
	size: PropTypes.string,
};

export default MarkerThumb;
